import * as yup from "yup";
import { TermsFormValues } from "src/pages/SmartCharging/CompCheck/Terms";

export const termsInputsFormSchema: yup.ObjectSchema<TermsFormValues> =
  yup.object({
    agb: yup
      .boolean()
      .required()
      .test("", "", function (value) {
        return value === true;
      }),
  });
